export var rcustomProp = /^--/;